<template>
  <van-popup
    v-model:show="rechargePopupConfig.isShow"
    class="recharge-page-popup"
    position="bottom"
    teleport="body"
    @open="openPopup"
  >
    <div class="recharge-page">
      <!-- firstRecharge -->
      <div v-if="isFirstCharge" class="firstRecharge">
        <img src="@/assets/image/recharge/img1.png" alt="" class="img1" />
      </div>
      <!-- selectRecharge -->
      <div class="selectRecharge">
        <div class="top flex s-b v-c">
          <div class="left">
            <h2>{{ $t('recharge.SR') }}</h2>
          </div>

          <div class="right flex center">
            <span class="value otw">{{ purseInfo?.chargeGoldNum }}</span>
            <img
              class="gold-img flex-none"
              src="@/assets/image/public/gold.png"
              alt=""
            />
          </div>
        </div>
        <div class="down flex v-c">
          <!-- 骨架屏 -->
          <template v-if="showMoneyList.length === 0">
            <div
              v-for="item in 3"
              :key="item"
              class="cell flex-none flex cell-skeleton"
            ></div>
          </template>

          <div
            v-for="(item, index) in showMoneyList"
            :key="item.chargeProdId"
            class="cell flex-none flex column h-c v-c"
            :class="{ active: moneyIndex === index }"
            @click="changeMoneyIndex(index)"
          >
            <div class="zs">
              <!-- 本地图片 -->
              <img src="@/assets/image/recharge/gold.png" alt="" />
            </div>
            <div class="now">
              {{
                !isFirstCharge
                  ? item.changeGoldRate
                  : item.changeGoldRate + item.firstGiftGoldNum
              }}
            </div>
            <div v-if="isFirstCharge" class="old">
              {{ item.changeGoldRate }}
            </div>
            <div class="price">$ {{ item.money }}</div>
          </div>
        </div>
      </div>
      <!-- selectPayment -->
      <div class="selectPayment">
        <div class="top flex s-b v-c">
          <div class="left">
            <h2>{{ $t('recharge.SP') }}</h2>
          </div>
          <div class="right flex s-b v-c">
            <div class="country flex center" @click="handleShowPicker">
              <span>{{ dropText }}</span>
              <van-icon name="arrow-down" />
            </div>
          </div>
        </div>
        <ul class="list flex v-c">
          <li
            v-for="(item, index) in payList"
            :key="index"
            class="cell flex v-c"
            :class="payIndex === index ? 'active' : ''"
            @click="selectPay(index)"
          >
            <!-- 本地图片 -->
            <img :src="item.imgurl" alt="" />
            <span>{{ item.text }}</span>
          </li>
        </ul>
      </div>
      <!-- payNow -->
      <van-button
        class="payNow"
        :disabled="showMoneyList.length === 0"
        :loading="rechargeClickLoading"
        @click="rechargeClick"
      >
        {{ $t('recharge.PN') }}
      </van-button>
    </div>
    <Picker
      ref="countryPicker"
      :title="$t('editProfile.Country')"
      :confirm-button-text="$t('editProfile.Confirm')"
      @on-confirm="onConfirmCountry"
    ></Picker>
  </van-popup>
</template>

<!-- 充值弹窗，和充值页面共用 ts 和 style -->

<script lang="ts" src="./ts/index.ts"></script>

<style lang="scss">
@import '../scss/index.scss';
@import './scss/RechargePopup.scss';
</style>
